// extracted by mini-css-extract-plugin
export default {"container":"jX-z","title":"kX-z","link":"lX-z"};